import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    container: {
        width: 'auto',
        height: '54px',
        flexShrink: 0,
        position: 'absolute' as const,
        top: 0,
        right: 0,
        zIndex: 100
    },
    logout: {
        border: `1px solid ${theme?.app?.applicationColors.enumColors.greyLighter ||
        '#CFCFCF'}`,
        borderRadius: '23px',
        padding: '.25rem 1rem',
        letterSpacing: '.05rem',
        fontWeight: 'normal' as const,
        marginRight: '4.25rem',
        marginLeft: '1.5rem'
    }
});